import { Sparkles, KeySquare, KeyRound } from 'lucide-react';
import type { HubSection } from '@/components/layout/HubLayout';

export type CredentialsScope = 'personal' | 'team' | 'organization';

export const PERSONAL_CREDENTIALS_SECTIONS: HubSection[] = [
  {
    id: 'model-providers',
    label: 'Model Providers',
    icon: Sparkles,
    description: 'Personal API keys and subscriptions.',
  },
  {
    id: 'api-keys',
    label: 'API Keys',
    icon: KeySquare,
    description: 'Personal keys for the Reflex API and SDK.',
  },
  {
    id: 'secrets',
    label: 'Secrets',
    icon: KeyRound,
    description: 'Personal key/value secrets for your agents.',
  },
];

export const TEAM_CREDENTIALS_SECTIONS: HubSection[] = [
  {
    id: 'model-providers',
    label: 'Model Providers',
    icon: Sparkles,
    description: 'Team model API keys.',
    permission: 'secrets:read',
  },
  {
    id: 'secrets',
    label: 'Secrets',
    icon: KeyRound,
    description: 'Team-scoped credentials.',
    permission: 'secrets:read',
  },
];

export const ORGANIZATION_CREDENTIALS_SECTIONS: HubSection[] = [
  {
    id: 'model-providers',
    label: 'Model Providers',
    icon: Sparkles,
    description: 'Organization-wide model API keys.',
    permission: 'secrets:read',
  },
  {
    id: 'secrets',
    label: 'Secrets',
    icon: KeyRound,
    description: 'Organization-wide credential store.',
    permission: 'secrets:read',
  },
];

export function defaultSectionForCredentialsScope(scope: CredentialsScope): string {
  switch (scope) {
    case 'personal':
    case 'team':
    case 'organization':
      return 'model-providers';
    default:
      return 'model-providers';
  }
}

export function sectionsForCredentialsScope(scope: CredentialsScope): HubSection[] {
  switch (scope) {
    case 'personal':
      return PERSONAL_CREDENTIALS_SECTIONS;
    case 'team':
      return TEAM_CREDENTIALS_SECTIONS;
    case 'organization':
      return ORGANIZATION_CREDENTIALS_SECTIONS;
    default:
      return PERSONAL_CREDENTIALS_SECTIONS;
  }
}

export function credentialsHubSection(scope: CredentialsScope, id: string): HubSection | undefined {
  return sectionsForCredentialsScope(scope).find((s) => s.id === id);
}
